import styled from "styled-components";

export const Container = styled.div`
  position: relative;

  .search-input {
    position: absolute;
    top: 10px;
    left: 15px;
  }
`;

export const Input = styled.input`
  width: 100%;
  height: 50px;
  background-color: white;
  border: 1px solid #c4c4c4;
  border-radius: 10px;
  position: relative;
  padding-left: 6rem;
`;
